import ecoAllianceVideoReel from './contentfulExports/ecoAllianceVideoReel.json'

const useEcoAllianceReels = () => {
  return ecoAllianceVideoReel;
}

export default useEcoAllianceReels;
